import React, { useState, useEffect } from 'react'
import { Divider } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import './login_register.css'
import { BASE_URL } from '../helper'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CircularProgress from '@mui/material/CircularProgress';

export default function Register() {

    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const [showCPassword, setShowCPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleCPasswordVisibility = () => {
        setShowCPassword(!showCPassword);
    };


    const [userdata, setuserdata] = useState({ fname: "", email: "", mobile: "", password: "", cpassword: "" })

    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await fetch(`${BASE_URL}/api/createuser`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: userdata.fname,
                email: userdata.email,
                mobile: userdata.mobile,
                password: userdata.password,
                cpassword: userdata.cpassword
            })
        });
        const json = await response.json()
        console.log(json);


        if (json.success) {
            toast.success("Registration Successfully done 😃!", {
              position: "top-center",
              autoClose: 2000,
              onClose: () => {
                navigate("/login");
              }
            });
          } else if (json.errors) {
            toast.error(json.errors, {
              position: "top-center",
              autoClose: 2000,
            });
          } else if (userdata.password !== userdata.cpassword) {
            toast.error("Passwords do not match 👎!", {
              position: "top-center",
              autoClose: 2000,
            });
        }
    }

    const changevalue = (event) => {
        setuserdata({ ...userdata, [event.target.name]: event.target.value })

    }

    useEffect(() => {
        // Simulating an asynchronous data fetch
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }, []);
    
      if (isLoading) {
        return (
          <div className="cart_section">
            <div className="circle">
              <CircularProgress />
              <h2>Loading....</h2>
            </div>
          </div>
        );
      }

    return (
        <>
            <div className="sign_container">
                <div className="sign_header">
                    <img src="./blacklogoamazon.png" alt="signupimg" />
                </div>
                <div className="sign_form">
                    <form onSubmit={handleSubmit}>
                        <h1>Create account</h1>
                        <div className="form_data">
                            <label htmlFor="name">Your name</label>
                            <input type="text" name="fname"
                                onChange={changevalue}
                                value={userdata.fname}
                                id="name" />
                        </div>
                        <div className="form_data">
                            <label htmlFor="email">email</label>
                            <input type="email" name="email"
                                onChange={changevalue}
                                value={userdata.email}
                                id="email" />
                        </div>
                        <div className="form_data">
                            <label htmlFor="mobile">Mobile number</label>
                            <input
                                type="text"
                                name="mobile"
                                pattern="[7-9]{1}[0-9]{9}"
                                onChange={changevalue}
                                value={userdata.mobile}
                                id="mobile"
                                required
                            />
                        </div>
                        <div className="form_data">
                            <label htmlFor="password">Password</label>
                            <div className="input-with-icon">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    onChange={changevalue}
                                    value={userdata.password}
                                    id="password"
                                    placeholder="At least 6 characters"
                                />
                                {showPassword ? (
                                    <VisibilityOff className="password-icon" onClick={togglePasswordVisibility} />
                                ) : (
                                    <Visibility className="password-icon" onClick={togglePasswordVisibility} />
                                )}
                            </div>
                        </div>
                        <div className="form_data">
                            <label htmlFor="passwordg">Password again</label>
                            <div className="input-with-icon">
                                <input
                                    type={showCPassword ? 'text' : 'password'}
                                    name="cpassword"
                                    onChange={changevalue}
                                    value={userdata.cpassword}
                                    id="passwordg"
                                />
                                {showCPassword ? (
                                    <VisibilityOff className="password-icon" onClick={toggleCPasswordVisibility} />
                                ) : (
                                    <Visibility className="password-icon" onClick={toggleCPasswordVisibility} />
                                )}
                            </div>
                        </div>
                        <button type="submit" className="signin_btn">Continue</button>
                        <Divider />
                        <div className="signin_info">
                            <p>Already have an account?</p>
                            <NavLink to="/login">Sign in</NavLink>
                        </div>
                    </form>
                </div>
                <ToastContainer />
            </div>
        </>
    )
}
